import { Select, MenuItem, Typography } from "@mui/material";
import i18n from "../../utils/i18n";
import { useSetLocale, useGetLocale, useInvalidate } from "@refinedev/core";
import { setAxiosLanguage } from "../../utils/axios";

export const LanguageSelect = () => {
  const changeLanguage = useSetLocale();
  const locale = useGetLocale();
  const currentLocale = locale();
  const invalidate = useInvalidate();

  const handleChangeLanguage = (lang: string) => {
    setAxiosLanguage(lang);
    changeLanguage(lang);
    invalidate({
      resource: "all",
      invalidates: ["all"],
    });
  };

  return (
    <Select
      size="small"
      value={currentLocale ?? " "}
      onChange={(e) => handleChangeLanguage(e.target.value)}
      variant="outlined"
      sx={{
        marginX: "16px",
      }}
    >
      {[...(i18n.languages ?? [])].map((lang: string) => (
        <MenuItem selected={currentLocale === lang} key={lang} value={lang}>
          <Typography color="text.secondary">
            {lang === "en" ? "English" : "Türkçe"}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};
